// extracted by mini-css-extract-plugin
module.exports = {"roomContainer":"room_info_roomContainer__36a8T"};